(function(){
'use strict';
var root = document.getElementById('aaRoot'); if(!root) return;
(function(){
var geo = root.getAttribute('data-geo'); if(!geo) return;
var p = window.location.pathname, ls = null;
try { ls = window.localStorage; } catch(e){}
var first = p.split('/')[1] || '';
if(first.length === 5 && first.charAt(2) === '-'){ try { if(ls) ls.setItem('aaGeo', '1'); } catch(e){} return; }
var done = null; try { done = ls ? ls.getItem('aaGeo') : null; } catch(e){}
var cc = (root.getAttribute('data-locale') || '').split('-')[1];
if(cc !== 'PL' || root.getAttribute('data-lang') !== 'en' || done) return;
if(/bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent)) return;
try { if(ls) ls.setItem('aaGeo', '1'); } catch(e){}
window.location.replace(geo + p + window.location.search + window.location.hash);
})();
var $ = function(s, c){ return (c || root).querySelector(s); };
var $$ = function(s, c){ return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var nav = document.getElementById('aaNav');
var waitlist = $$('[data-wl]').length > 0;
var uSec = null, uLabel = '', curQty = null, uIdx = 0;
root.style.setProperty('--aa-top', '0px');
function goTo(id){
var t = id && document.querySelector(id); if(!t) return;
if(t.tagName === 'DETAILS') t.open = true;
var off = id === '#aa-buy' ? 20 : (nav ? nav.offsetHeight : 0) + 10;
window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off, behavior: reduce ? 'auto' : 'smooth' });
}
var tabBtns = $$('[data-tab]'), tabPanels = $$('[data-panel]');
function showTab(name){
tabBtns.forEach(function(b){ var on = b.getAttribute('data-tab') === name; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; });
tabPanels.forEach(function(p){ p.hidden = p.getAttribute('data-panel') !== name; });
}
tabBtns.forEach(function(b, i){
b.addEventListener('click', function(){
showTab(b.getAttribute('data-tab'));
if(nav && nav.getBoundingClientRect().top <= 1) goTo('#aa-panels');   // bar is stuck: bring the panel into view
});
b.addEventListener('keydown', function(e){
var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if(!d) return;
var n = tabBtns[(i + d + tabBtns.length) % tabBtns.length]; n.focus(); n.click();
});
});
$$('[data-wa]').forEach(function(a){ a.addEventListener('click', function(){
var where = a.getAttribute('data-wa');
try { if(window.dataLayer) window.dataLayer.push({ event:'whatsapp_click', wa_location:where }); } catch(e){}
try { if(window.gtag) window.gtag('event', 'whatsapp_click', { wa_location:where }); } catch(e){}
try { if(window.fbq) window.fbq('trackCustom', 'WhatsAppClick', { wa_location:where }); } catch(e){}
}); });
$$('[data-scroll]').forEach(function(a){ a.addEventListener('click', function(e){
e.preventDefault();
var id = this.getAttribute('href');
if(id === '#aa-size'){ showTab('size'); goTo('#aa-panels'); return; }
goTo(id);
}); });
(function(){
var lines = $$('[data-fs-line]');
var base = parseFloat(root.getAttribute('data-fs-shop')) || 0;
var cur = root.getAttribute('data-currency');
var hasFixed = lines.length && /[0-9]/.test(lines[0].textContent);
if(hasFixed || !base || !window.Shopify || !Shopify.currency || !Shopify.currency.rate) return;
var amt = Math.ceil(base * parseFloat(Shopify.currency.rate) / 10) * 10, txt;
try { txt = new Intl.NumberFormat(root.getAttribute('data-locale'), { style:'currency', currency:cur, maximumFractionDigits:0 }).format(amt); }
catch(e){ txt = amt + ' ' + cur; }
var line = root.getAttribute('data-fs-tpl').replace('[x]', txt);
lines.forEach(function(l){ l.textContent = line; });
var faq = $('[data-fs-faq]'); if(faq) faq.textContent = faq.textContent.replace(/[0-9][0-9 .,]*[ ]?[^0-9 .,]+/, txt);
})();
var lb = document.getElementById('aaLb'), lbImg = lb.querySelector('img'), lastFocus = null;
function openLb(src){ if(!src) return; lastFocus = document.activeElement; lbImg.src = src; lb.classList.add('is-on'); document.body.style.overflow = 'hidden'; lb.querySelector('button').focus(); }
function closeLb(){ if(!lb.classList.contains('is-on')) return; lb.classList.remove('is-on'); document.body.style.overflow = ''; if(lastFocus) lastFocus.focus(); }
lb.addEventListener('click', closeLb);
document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeLb(); });
var galleries = $$('.aa-gal').map(function(el){
var main = $('[data-main]', el), img = $('[data-main-img]', el), thumbs = $$('.aa-thumb', el);
var prev = $('.aa-arrow--prev', el), next = $('.aa-arrow--next', el);
var dots = document.createElement('div'); dots.className = 'aa-dots'; dots.setAttribute('aria-hidden', 'true'); main.appendChild(dots);
function vis(){ return thumbs.filter(function(t){ return !t.hidden; }); }
function arrows(){
var v = vis(), i = v.findIndex(function(t){ return t.classList.contains('is-on'); });
dots.innerHTML = ''; v.forEach(function(t){ var d = document.createElement('i'); if(t.classList.contains('is-on')) d.className = 'is-on'; dots.appendChild(d); });
if(prev) prev.hidden = i <= 0;
if(next) next.hidden = i < 0 || i >= v.length - 1;
}
function setMain(src){
if(!src) return;
thumbs.forEach(function(t){ t.classList.toggle('is-on', t.getAttribute('data-src') === src); });
arrows();
if(img.getAttribute('src') === src) return;
img.classList.add('is-swapping');
setTimeout(function(){ img.onload = function(){ img.classList.remove('is-swapping'); }; img.removeAttribute('srcset'); img.src = src; }, reduce ? 0 : 180);
}
thumbs.forEach(function(t){ t.addEventListener('click', function(){ setMain(t.getAttribute('data-src')); }); });
$$('.aa-arrow', el).forEach(function(b){ b.addEventListener('click', function(e){
e.stopPropagation();
var v = vis(); if(!v.length) return;
var i = v.findIndex(function(t){ return t.classList.contains('is-on'); });
setMain(v[Math.min(v.length - 1, Math.max(0, i + parseInt(b.getAttribute('data-step'), 10)))].getAttribute('data-src'));
}); });
main.addEventListener('click', function(){ openLb(img.getAttribute('src')); });
return { thumbs:thumbs, img:img, vis:vis, setMain:setMain, arrows:arrows };
});
var variants = [];
try { variants = JSON.parse(document.getElementById('aaVariants').textContent); } catch(e){}
var colorIdx = parseInt(root.getAttribute('data-color-idx'), 10);
var forms = $$('form').filter(function(f){ return f.classList.contains('aa-form') || (f.getAttribute('action') || '').indexOf('/cart/add') > -1; });
var valBtns = $$('.aa-val');
var optCount = variants.length ? variants[0].options.length : 0;
var current = variants.filter(function(v){ return String(v.id) === root.getAttribute('data-variant'); })[0] || variants[0];
var sel = current ? current.options.slice() : [];
var colorIndexOf = {};
valBtns.forEach(function(b){ if(b.hasAttribute('data-ci')) colorIndexOf[b.getAttribute('data-value')] = b.getAttribute('data-ci'); });
function find(opts){
for(var i = 0; i < variants.length; i++){
var ok = true;
for(var k = 0; k < optCount; k++){ if(variants[i].options[k] !== opts[k]){ ok = false; break; } }
if(ok) return variants[i];
}
return null;
}
function withValue(k, val){ var o = sel.slice(); o[k] = val; return find(o); }
function setText(sel2, v){ $$(sel2).forEach(function(el){ el.textContent = v; }); }
function setTp(n, t){ $$('[data-tp]').forEach(function(el){ if(el.getAttribute('data-tp') === n) el.textContent = t; }); }
function filterThumbs(g){
if(colorIdx < 0) return;
var ci = colorIndexOf[sel[colorIdx]];
var tagged = g.thumbs.filter(function(t){ return t.getAttribute('data-ci') !== ''; });
if(!tagged.length || ci === undefined) return;
if(!tagged.some(function(t){ return t.getAttribute('data-ci') === ci; })) return;
g.thumbs.forEach(function(t){ var c = t.getAttribute('data-ci'); t.hidden = c !== '' && c !== ci; });
}
function render(colorChanged){
var v = find(sel);
valBtns.forEach(function(b){
var k = parseInt(b.getAttribute('data-opt'), 10), val = b.getAttribute('data-value');
var cand = withValue(k, val), on = sel[k] === val;
b.classList.toggle('is-on', on);
b.setAttribute('aria-pressed', on);
b.classList.toggle('is-off', !!cand && !cand.available);
b.hidden = (k !== colorIdx && !cand);
});
$$('[data-optval]').forEach(function(el){
var k = el.getAttribute('data-optval');
var hit = valBtns.filter(function(b){ return b.getAttribute('data-opt') === k && b.classList.contains('is-on'); })[0];
el.textContent = hit ? (hit.getAttribute('data-label') || '') : '';
});
updateWl(v);
if(v){
$$('.aa-vid').forEach(function(i){ i.value = v.id; });
setText('[data-price]', v.price);
setTp('1', v.price); setTp('2', v.t2); setTp('3', v.t3);
$$('[data-regular]').forEach(function(el){ el.hidden = !v.compare; });
$$('[data-compare]').forEach(function(el){ el.hidden = !v.compare; if(v.compare) el.textContent = v.compare; });
$$('[data-off]').forEach(function(el){ el.hidden = !(v.pct > 0); });
setText('[data-off-n]', v.pct);
try { if(window.history && history.replaceState){ var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } } catch(e){}
}
curQty = (v && v.q !== null && v.q !== undefined) ? v.q : null;
updateLow();
forms.forEach(function(f){
var sb = $('[data-submit]', f), st = $('[data-submit-txt]', f);
if(v && v.available){ sb.disabled = false; st.textContent = sb.getAttribute('data-t-btn'); }
else if(v){ sb.disabled = true; st.textContent = sb.getAttribute('data-t-unavail'); }
else { sb.disabled = true; st.textContent = sb.getAttribute('data-t-pick'); }
$('[data-msg]', f).textContent = '';
});
if(colorChanged){
galleries.forEach(function(g){
filterThumbs(g);
var tagged = g.thumbs.some(function(t){ return t.getAttribute('data-ci') !== ''; });
var vs = g.vis();
g.setMain(tagged ? (vs[0] && vs[0].getAttribute('data-src')) : (v && v.img));
});
}
}
function pick(k, val){
$$('[data-wl]').forEach(function(b){ b.removeAttribute('data-wl-sent'); });
var prev = sel[k]; sel[k] = val;
var v = find(sel);
if(!v || (!v.available && !waitlist)){
var alt = variants.filter(function(x){ return x.options[k] === val && x.available; })[0]
|| variants.filter(function(x){ return x.options[k] === val; })[0];
if(alt) sel = alt.options.slice();
}
render(k === colorIdx && prev !== val);
}
valBtns.forEach(function(b){ b.addEventListener('click', function(){
var k = parseInt(b.getAttribute('data-opt'), 10);
if(b.classList.contains('is-off') && k !== colorIdx && !waitlist) return;
pick(k, b.getAttribute('data-value'));
}); });
galleries.forEach(function(g){
filterThumbs(g);
var f = g.vis().filter(function(t){ return t.getAttribute('data-src') === g.img.getAttribute('src'); })[0] || g.vis()[0];
if(f) f.classList.add('is-on');
g.arrows();
});
render(false);
(function(){
var fl = null;
try { fl = JSON.parse(sessionStorage.getItem('aaWlSent') || 'null'); } catch(e){}
if(!fl) return;
try { sessionStorage.removeItem('aaWlSent'); } catch(e){}
var fresh = (Date.now() - fl.t) < 900000;
var back = /[?&]contact_posted=true/.test(window.location.search) || /challenge/.test(document.referrer || '');
if(!fresh || !back) return;
var box = $('[data-wl]'); if(!box) return;
box.hidden = false; box.setAttribute('data-wl-sent', '1'); box.classList.add('is-sent');
var h = $('.aa-wl__h', box); if(h) h.hidden = true;
$('[data-wl-body]', box).hidden = true; $('[data-wl-err]', box).hidden = true; $('[data-wl-ok]', box).hidden = false;
try { history.replaceState(null, '', window.location.pathname + window.location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '')); } catch(e){}
try { box.scrollIntoView({ block:'center', behavior: reduce ? 'auto' : 'smooth' }); } catch(e){}
})();
function setQty(n){
$$('.aa-qty-input').forEach(function(i){ i.value = n; });
$$('.aa-tier').forEach(function(x){ var on = x.getAttribute('data-qty') === String(n); x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
}
$$('.aa-tier').forEach(function(b){ b.addEventListener('click', function(){ setQty(b.getAttribute('data-qty')); }); });
$$('[data-qty-step]').forEach(function(b){ b.addEventListener('click', function(){
var cur = parseInt($('.aa-qty-input').value, 10) || 1;
setQty(Math.min(10, Math.max(1, cur + parseInt(b.getAttribute('data-qty-step'), 10))));
}); });
function selLabel(){
var out = [];
for(var k = 0; k < optCount; k++){
var hit = valBtns.filter(function(b){ return b.getAttribute('data-opt') === String(k) && b.classList.contains('is-on'); })[0];
out.push(hit && hit.getAttribute('data-label') ? hit.getAttribute('data-label') : sel[k]);
}
return out.join(' / ');
}
function updateWl(v){
$$('.aa-stock').forEach(function(el){ el.hidden = !!v && !v.available; });
$$('[data-wl]').forEach(function(box){
if(box.getAttribute('data-wl-sent') === '1') return;
var show = !!v && !v.available;
var was = !box.hidden;
box.hidden = !show;
if(show){
$('[data-wl-var]', box).textContent = selLabel();
if(!was || box.getAttribute('data-wl-key') !== sel.join('|')){
box.setAttribute('data-wl-key', sel.join('|')); box.classList.remove('is-sent'); var hh = $('.aa-wl__h', box); if(hh) hh.hidden = false;
$('[data-wl-body]', box).hidden = false; $('[data-wl-ok]', box).hidden = true; $('[data-wl-err]', box).hidden = true;
}
}
});
}
$$('[data-ph-s]').forEach(function(i){ if(window.matchMedia && window.matchMedia('(max-width: 480px)').matches) i.placeholder = i.getAttribute('data-ph-s'); });
$$('[data-wl] form').forEach(function(wf){
function setF(n, v){ var el = $('[data-wl-f=' + n + ']', wf); if(el) el.value = v; }
wf.addEventListener('submit', function(e){
e.preventDefault();
var box = wf.parentNode, handle = root.getAttribute('data-handle') || '';
var kind = 'notify';
$$('input[name=wl_type]', wf).forEach(function(r){ if(r.checked) kind = r.value; });
var kindTxt = kind === 'custom' ? 'specjalne zamowienie' : 'powiadomic o dostepnosci';
var phone = $('input[type=tel]', wf).value;
var variant = sel.join(' / ');
setF('product', handle); setF('variant', variant); setF('type', kindTxt);
setF('body', 'Lista oczekujacych | ' + handle + ' | ' + variant + ' | ' + kindTxt + (phone ? ' | tel: ' + phone : ''));
var okEl = $('[data-wl-ok]', box), errEl = $('[data-wl-err]', box), body = $('[data-wl-body]', box);
errEl.hidden = true;
function ok(){ var h = $('.aa-wl__h', box); if(h) h.hidden = true; body.hidden = true; okEl.hidden = false; box.classList.add('is-sent'); try { box.scrollIntoView({ block:'center', behavior: reduce ? 'auto' : 'smooth' }); } catch(e){} }
function plain(){ try { sessionStorage.setItem('aaWlSent', JSON.stringify({ t: Date.now() })); } catch(e){} wf.submit(); }
var data = new URLSearchParams(new FormData(wf));
fetch(wf.getAttribute('action'), { method:'POST', body:data, headers:{ 'Content-Type':'application/x-www-form-urlencoded' }, credentials:'same-origin' })
.then(function(r){
var u = r.url || '';
if(u.indexOf('challenge') > -1){ plain(); return; }
if(u.indexOf('contact_posted') > -1 || (r.redirected && u.indexOf('/contact') > -1)){ ok(); return; }
plain();
})
.catch(plain);
});
});
forms.forEach(function(form){
var sb = $('[data-submit]', form), st = $('[data-submit-txt]', form), msg = $('[data-msg]', form);
form.addEventListener('submit', function(e){
e.preventDefault(); if(sb.disabled) return;
sb.disabled = true; st.textContent = sb.getAttribute('data-t-adding'); msg.textContent = '';
var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
var fd = new FormData(form);
if(cartEl && typeof cartEl.getSectionsToRender === 'function'){
fd.append('sections', cartEl.getSectionsToRender().map(function(s){ return s.id; }));
fd.append('sections_url', window.location.pathname);
if(typeof cartEl.setActiveElement === 'function') cartEl.setActiveElement(document.activeElement);
}
fetch(root.getAttribute('data-add-url') + '.js', { method:'POST', body:fd, headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' } })
.then(function(r){ return r.json().then(function(j){ return { ok:r.ok, j:j }; }); })
.then(function(res){
if(!res.ok || res.j.status){ throw new Error(res.j.description || res.j.message || 'Error'); }
st.textContent = sb.getAttribute('data-t-added');
if(cartEl && typeof cartEl.renderContents === 'function'){
if(cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
cartEl.renderContents(res.j);
setTimeout(function(){ sb.disabled = false; st.textContent = sb.getAttribute('data-t-btn'); }, 1200);
} else { window.location.href = root.getAttribute('data-cart-url'); }
})
.catch(function(err){ msg.textContent = err.message; sb.disabled = false; st.textContent = sb.getAttribute('data-t-btn'); });
});
});
$$('[data-chart]').forEach(function(box){
var btns = $$('.aa-chart__btn', box), imgs = $$('[data-chart-img]', box);
btns.forEach(function(b){ b.addEventListener('click', function(){
var u = b.getAttribute('data-unit');
btns.forEach(function(x){ x.classList.toggle('is-on', x === b); });
imgs.forEach(function(i){ i.hidden = i.getAttribute('data-chart-img') !== u; });
}); });
});
$$('[data-more]').forEach(function(b){ b.addEventListener('click', function(){ $$('[data-extra]').forEach(function(e){ e.hidden = false; }); b.hidden = true; }); });
function lowMax(){ return parseInt(root.getAttribute('data-lowmax'), 10) || 25; }
function lowOn(){ return curQty !== null && curQty > 0 && curQty <= lowMax(); }
function urgentMsgs(el){
var m = [];
if(lowOn()) m.push(el.getAttribute('data-low').replace('[n]', curQty));
if(el.getAttribute('data-m1')) m.push(el.getAttribute('data-m1'));
if(uSec !== null && root.getAttribute('data-presale') === 'true') m.push(el.getAttribute('data-time').replace('[t]', compact(uSec)).replace('[d]', uLabel || ''));
m.push(el.getAttribute('data-m3'));
m.push(el.getAttribute('data-m4'));
return m;
}
function paintUrgent(animate){
$$('[data-urgent]').forEach(function(el){
var t = $('[data-urgent-t]', el), msgs = urgentMsgs(el), txt = msgs[uIdx % msgs.length];
if(t.textContent === txt) return;
if(animate && !reduce){ t.classList.add('is-out'); setTimeout(function(){ t.textContent = txt; t.classList.remove('is-out'); }, 280); }
else { t.textContent = txt; }
});
}
function updateLow(){
$$('[data-lowbar]').forEach(function(b){
var on = lowOn(); b.hidden = !on;
if(on) b.firstElementChild.style.width = Math.max(8, Math.min(100, Math.round(curQty / lowMax() * 100))) + '%';
});
paintUrgent(false);
}
if(!reduce){ setInterval(function(){ uIdx++; paintUrgent(true); }, 4600); }
var stocks = $$('[data-stock]'), closeH = $('[data-close-h]');
var isPresale = root.getAttribute('data-presale') === 'true';
var deadline = new Date(root.getAttribute('data-deadline') || '').getTime();
var cutoff = parseInt(root.getAttribute('data-cutoff'), 10) || 14;
var lang = root.getAttribute('data-lang') || 'en';
var TZ = 'Europe/Warsaw';
var NB = String.fromCharCode(160);
function nb(x){ return x.replace(/ /g, NB); }
function parts(sec){ return { d:Math.floor(sec / 86400), h:Math.floor(sec % 86400 / 3600), m:Math.floor(sec % 3600 / 60), s:Math.floor(sec % 60) }; }
function compact(sec){
var p = parts(sec), out = [];
if(p.d) out.push(p.d + root.getAttribute('data-ud'));
if(p.d || p.h) out.push(p.h + root.getAttribute('data-uh'));
out.push(p.m + root.getAttribute('data-um')); out.push(p.s + root.getAttribute('data-us'));
return out.map(nb).join(' ');
}
function colon(sec){
var p = parts(sec), out = [];
if(p.d) out.push(p.d + root.getAttribute('data-cud'));
if(p.d || p.h) out.push(p.h + root.getAttribute('data-cuh'));
out.push(p.m + root.getAttribute('data-cum')); out.push(p.s + root.getAttribute('data-cus'));
return out.map(nb).join(' : ');
}
function warsawNow(){
var f = new Intl.DateTimeFormat('en-GB', { timeZone:TZ, hourCycle:'h23', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit' });
var p = {}; f.formatToParts(new Date()).forEach(function(x){ p[x.type] = x.value; });
return { y:+p.year, m:+p.month, d:+p.day, h:+p.hour, mi:+p.minute, s:+p.second };
}
function dispatch(){
var n = warsawNow(), now = Date.UTC(n.y, n.m - 1, n.d, n.h, n.mi, n.s);
var day = new Date(Date.UTC(n.y, n.m - 1, n.d)), dow = day.getUTCDay();
if(dow === 0 || dow === 6 || n.h >= cutoff){ do { day = new Date(day.getTime() + 864e5); dow = day.getUTCDay(); } while(dow === 0 || dow === 6); }
var target = Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), cutoff, 0, 0);
var diffDays = Math.round((day.getTime() - Date.UTC(n.y, n.m - 1, n.d)) / 864e5), label;
if(diffDays === 0) label = root.getAttribute('data-today');
else if(diffDays === 1) label = root.getAttribute('data-tomorrow');
else { try { label = new Intl.DateTimeFormat(lang, { timeZone:'UTC', weekday:'long', day:'numeric', month:'long' }).format(day); } catch(e){ label = day.toDateString(); } }
return { sec:(target - now) / 1000, label:label };
}
function paint(sec, label){
uSec = sec; uLabel = label || '';
stocks.forEach(function(s){
if(sec === null){ s.innerHTML = s.getAttribute('data-static'); return; }
s.innerHTML = s.getAttribute('data-live').replace('[t]', compact(sec)).replace('[d]', label || '');
});
paintUrgent(false);
if(!closeH) return;
if(sec === null){ closeH.textContent = closeH.getAttribute('data-b-end'); return; }
var a = closeH.getAttribute('data-a'), b = closeH.getAttribute('data-b').replace('[d]', label || '');
closeH.innerHTML = '';
closeH.appendChild(document.createTextNode(a + ' '));
var t = document.createElement('span'); t.className = 'aa-close__t'; t.textContent = colon(sec); closeH.appendChild(t);
closeH.appendChild(document.createElement('br'));
closeH.appendChild(document.createTextNode(b));
}
function tick(){
if(isPresale){
var diff = (deadline - Date.now()) / 1000;
if(!isNaN(deadline) && diff > 0){ paint(diff); setTimeout(tick, 1000); } else { paint(null); }
} else {
var dp = dispatch(); paint(dp.sec, dp.label); setTimeout(tick, 1000);
}
}
try { tick(); } catch(e){ paint(null); }
})();